var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9643 0L14.9286 3.03571L7.46429 10.5L4.5 7.53571L11.9643 0Z",
    fill: "#F0B90B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4643 4.5L19.4286 7.53571L7.46429 19.5L4.5 16.5357L16.4643 4.5Z",
    fill: "#F0B90B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96429 9L5.92857 12.0357L2.96429 15L0 12.0357L2.96429 9Z",
    fill: "#F0B90B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9643 9L23.9286 12.0357L11.9643 24L9 21.0357L20.9643 9Z",
    fill: "#F0B90B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusd);
export default __webpack_public_path__ + "static/media/BUSD.b496f3c89a09718958fe0b64905772dd.svg";
export { ForwardRef as ReactComponent };